import React, { useEffect } from 'react';
import styled from 'styled-components';
import SanityImage from 'gatsby-plugin-sanity-image';
import SupportArticleText from '@rsc/ui-components/support-article/support-article-section-types/SupportArticleText';
import sharedStyles from '@rsc/ui-components/styles';
import breakpoints from '@rsc/ui-components/breakpoints';

const StepByStepContainer = styled.div``;

const SupportStepCalloutWrapper = styled.div`
  background: ${({ theme }) => theme.colors.callout};
  color: #262626;
  font-size: ${sharedStyles.fontSize['1xl']};
  font-weight: ${sharedStyles.fontWeight.bold};
  margin-bottom: 2rem;
  text-align: center;

  > p {
    padding: 0.5rem;
  }
`;

const StepByStepWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
`;

const StepByStepItem = styled.div`
  flex: 0 0 100%;
  margin-bottom: 1.25em;

  a {
    &:hover {
      color: ${({ theme }) => theme.colors.linkHover};
    }
  }

  h2 {
    margin: 0.25em 0;
  }

  img {
    width: 100%;
    margin-bottom: 0.25em;
  }

  @media (min-width: ${breakpoints.md}) {
    flex: 0 0 47%;
  }

  @media (min-width: ${breakpoints.lg}) {
    flex: 0 0 30%;
  }
`;

const StepByStepItemMedia = styled.div`
  padding: revert;

  img {
    height: 300px;
    object-fit: contain;
  }

  lite-youtube {
    border: none;
    height: 300px;
  }
`;

const StepByStepItemDescription = styled.div`
  display: flex;
  justify-content: center;
`;

const StepIcon = styled.i`
  height: 2rem;
  color: ${({ theme }) => theme.colors.brandPrimary};
  font-size: 1.875em;
  margin-right: 0.5rem;
`;

const StepIconWrapper = styled.div``;

const StepDescriptionWrapper = styled.div`
  padding: 0;
  margin-top: auto;
  margin-bottom: auto;

  > p {
    margin: 0;
    vertical-align: center;
  }
`;

function SupportArticleStepByStep({ section }) {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      import('lite-youtube-embed');
    }
  }, []);

  return (
    <StepByStepContainer>
      {section?.text && <p>{section?.text}</p>}
      <SupportStepCalloutWrapper>
        {section?.callout && <p>{section.callout}</p>}
      </SupportStepCalloutWrapper>
      <StepByStepWrapper count={section.steps?.length || 0}>
        {section?.steps?.map((step, index) => {
          return (
            <StepByStepItem key={step._key}>
              <StepByStepItemMedia>
                {step?.image?.asset && (
                  <SanityImage
                    asset={step?.image?.asset}
                    alt={step?.image?.alt}
                  />
                )}
                {step?.video?.url && !step?.image?.asset && (
                  <lite-youtube
                    title={step?.video?.caption}
                    videoid={step?.video?.id}
                    frameBorder="0"
                    allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    style={{
                      backgroundImage: `url('https://i.ytimg.com/vi/${step?.video?.id}/maxresdefault.jpg')`,
                    }}
                    params="rel=0&listType=playlist&loop=1&showinfo=0&iv_load_policy=30&start=0&end=0"
                  />
                )}
              </StepByStepItemMedia>
              <StepByStepItemDescription>
                {step?.icon && (
                  <StepIconWrapper>
                    <StepIcon className={step?.icon} />
                  </StepIconWrapper>
                )}
                {step?.description?.text && (
                  <StepDescriptionWrapper>
                    <SupportArticleText text={step?.description?.text} />
                  </StepDescriptionWrapper>
                )}
              </StepByStepItemDescription>
            </StepByStepItem>
          );
        })}
      </StepByStepWrapper>
    </StepByStepContainer>
  );
}

export default SupportArticleStepByStep;
